import { useEffect, useState } from "react";
import {
  Button,
  Box,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { UseAdvertisingManage } from "./UseAdvertisingManage";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import AdvertismentsAutoComplete from "../advertisments/AdvertismentsAutoComplete";
import AdvContractAutoComplete from "../adv-contract/AdvContractAutoComplete";

export default function AddAdvManage(props) {
  const { toSolar } = require("jdate-convert");
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [group, setAdvManage] = useState();
  const { validate, addAdvertisingManage } = UseAdvertisingManage();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { isSmall } = useBreakpoints();
  const [valueStart, setValueStart] = useState();
  const [valueEnd, setValueEnd] = useState();
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];
  const [valueLogdate, setValueLogdate] = useState();

  const [state, setState] = useState({
    id: undefined,
    title: undefined,
    startDate: undefined,
    endDate: undefined,
    advertismentID: undefined,
    description: undefined,
    done: false,
  });

  const [errorState, setErrorState] = useState({
    title: false,
    advertismentID: false,
    startDate: false,
    endDate: false,
  });

  useEffect(() => {
    let newValueStart = valueStart?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    setState({ ...state, startDate: newValueStart });
  }, [valueStart]);

  useEffect(() => {
    let newValueEnd = valueEnd?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    setState({ ...state, endDate: newValueEnd });
  }, [valueEnd]);

  useEffect(() => {
    let newValueEnd = valueLogdate?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    setState({ ...state, logdate: newValueEnd });
  }, [valueLogdate]);

  return (
    <Detail
      breadChilds={{
        title: "تبلیغات",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/advertisingmanage" },
          {
            name: "تبلیغ جدید",
            url: "/advertisingmanage/addAdvertisingManage",
          },
        ],
      }}
    >
      {!group ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.title ? state.title : ""}
              error={errorState.title}
              label="عنوان"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, title: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <DatePicker
              weekDays={weekDays}
              calendar={persian}
              locale={persian_fa}
              format="YYYY-MM-DD"
              onChange={setValueLogdate}
              value={state && state.logdate ? toSolar(state.logdate) : ""}
              render={
                <TextField
                  sx={{ pr: 2, input: { textAlign: "center" } }}
                  variant="outlined"
                  size="small"
                  fullWidth
                  label="تاریخ ثبت"
                  error={errorState.logdate}
                />
              }
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 4"}>
            <AdvContractAutoComplete
              selectedContractID={state.contractID}
              state={state}
              setState={setState}
              onSelect={(contract) =>
                setState({ ...state, contractID: contract })
              }
            />
          </Box>
          {!isSmall && <Box gridColumn="span 8"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <AdvertismentsAutoComplete
              selectedAdvertismentID={state.advertismentID}
              state={state}
              setState={setState}
              errorState={errorState.advertismentID}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}

          <Box
            sx={{ display: "flex", gap: 2 }}
            gridColumn={isSmall ? "span 12" : "span 7"}
          >
            <DatePicker
              weekDays={weekDays}
              calendar={persian}
              locale={persian_fa}
              format="YYYY-MM-DD"
              onChange={setValueStart}
              value={state && state.startDate ? toSolar(state.startDate) : ""}
              render={
                <TextField
                  sx={{ pr: 2, input: { textAlign: "center" } }}
                  variant="outlined"
                  size="small"
                  fullWidth
                  label="تاریخ شروع"
                  error={errorState.startDate}
                />
              }
            />
            <DatePicker
              weekDays={weekDays}
              calendar={persian}
              locale={persian_fa}
              format="YYYY-MM-DD"
              value={state && state.endDate ? toSolar(state.endDate) : ""}
              // value={valueEnd}
              onChange={setValueEnd}
              render={
                <TextField
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  label="تاریخ پایان"
                  size="small"
                  fullWidth
                  error={errorState.endDate}
                />
              }
            />
          </Box>
          {!isSmall && <Box gridColumn="span 5"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 4"}>
            <TextField
              fullWidth
              value={state.description ? state.description : ""}
              label="توضیحات"
              multiline
              rows={3}
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, description: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 8"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 7"}>
            <FormControlLabel
              checked={state.done ? state.done : false}
              onChange={(evt) => {
                setState({ ...state, done: evt.target.checked });
              }}
              control={<Checkbox sx={{ py: 0 }} />}
              label="اتمام"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 5"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  setMsGotoLast(true);
                  addAdvertisingManage(state, () => {
                    navigate("/advertisingmanage", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/advertisingmanage", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
